import { render } from "./warning-message.vue?vue&type=template&id=64f09922&scoped=true&ts=true"
import script from "./warning-message.ts?vue&type=script&lang=ts&external"
export * from "./warning-message.ts?vue&type=script&lang=ts&external"

import "./warning-message.scss?vue&type=style&index=0&id=64f09922&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f09922"]])

export default __exports__